import React, { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { usePwaInstallPrompt } from './PwaInstallContext';
import './pwa.css';

export default function PwaInstallBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(false);
  const {
    canPrompt,
    dismissed,
    dismiss,
    isAndroid,
    isIos,
    openInstalledAppMessage,
    promptInstall,
    shouldShowInstallUi,
    shouldShowOpenAppUi,
  } = usePwaInstallPrompt();

  const showOpenAppUi = shouldShowOpenAppUi && !dismissed;

  if (hidden || !user || (!shouldShowInstallUi && !showOpenAppUi)) return null;

  let bannerMessage = 'Add Member Nest to this device for quicker access and push notifications.';
  if (showOpenAppUi) {
    bannerMessage = openInstalledAppMessage;
  } else if (isIos && !canPrompt) {
    bannerMessage = 'Use Share, then Add to Home Screen for the app experience on this device.';
  } else if (isAndroid && !canPrompt) {
    bannerMessage = 'Use your browser menu and choose Install app or Add to Home screen.';
  }

  const handleDismiss = () => {
    setHidden(true);
    if (showOpenAppUi) dismiss();
  };

  return (
    <div className="pwa-install-banner" role="region" aria-label="Install Member Nest">
      <div>
        <strong>{showOpenAppUi ? 'Open the installed app' : 'Install Member Nest'}</strong>
        <span>{bannerMessage}</span>
      </div>
      {canPrompt && shouldShowInstallUi && (
        <button type="button" className="button pwa-install-banner__button" onClick={promptInstall}>
          Install
        </button>
      )}
      <button type="button" className="pwa-install-banner__dismiss" onClick={handleDismiss} aria-label="Dismiss install prompt">
        ×
      </button>
    </div>
  );
}
